import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadKangoo2014Images";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-kangoo2014/")({
  head: () => routeHead("/admin/upload-kangoo2014/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
